<template>
<!--	<section :id="data.id" class="content-boxes">-->
<!--		<ContentBox-->
<!--			v-for="(contentBox, index) in contentBoxes"-->
<!--			:key="`${contentBox.id}-${index}`"-->
<!--			:id="contentBox?.sys?.id"-->
<!--			:content="contentBox.fields"-->
<!--		/>-->
<!--	</section>-->
	<section class="text-block">
		<div class="container">
			<RichText v-if="textBlock?.text" :content="textBlock.text.content" :textAlignment="textBlock.textAlignment" />
		</div>
	</section>
</template>

<script setup>
const props = defineProps({
	data: {
		type: Object
	}
});

const textBlock = computed(() => {
	return props?.data?.data;
});
</script>

<style lang="scss">
@use '~/assets/scss/components/TextBlock.scss';
</style>
